export const navigationAfterLogin = (roles: string[]): string => {
  if (roles.includes('ADMIN')) return '/admin/empresas';
  if (roles.includes('AUDITOR')) return '/empresa/auditoria';
  if (
    roles.some((role) =>
      ['ADMIN_EMPRESA', 'TESORERO', 'ANALISTA_FINANCIERO', 'CONSULTA'].includes(role),
    )
  ) {
    return '/tesoreria/cuentas';
  }

  return '/no-autorizado';
};
